export default __webpack_public_path__ + "static/media/ux.81923f31.png";